export const copyObjRemoveNullValue = (obj: any) => {
  const newObj = { ...obj };
  Object.keys(newObj).forEach((key) => {
    if (!newObj[key]) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const concatPromptString = (arr: string[]) =>
  arr.reduce((prev, cur) => {
    if (!cur) return prev;
    if (cur[cur.length - 1] === ",") return prev + cur;
    return prev + "," + cur;
  }, "");
